module.exports = __webpack_public_path__ + "img/apply.d58f7712.png";